import { ActionButtons, Footer, TextAreaField } from "@ucl/library";
import { useState } from "react";

export interface TaskExecutionWithdrawComponentProps {
  onWithdraw: (reason: string) => Promise<void>;
  onCancel: () => void;
}

export const TaskExecutionWithdrawComponent: React.FC<
  TaskExecutionWithdrawComponentProps
> = (props) => {
  const [formState, setFormState] = useState<{ reason: string }>({
    reason: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  return (
    <section className="task-execution-withdraw-component">
      <TextAreaField
        type="TextArea"
        fieldName="reason"
        fieldKey="reason"
        label="Reason for Withdrawal"
        placeholder="Type here..."
        isRequired={true}
        value={formState.reason}
        onSubmit={function (value) {
          setFormState({
            ...formState,
            reason: value as string,
          });
        }}
      />
      <Footer>
        <ActionButtons
          actions={[
            {
              text: "Cancel",
              isPrimary: false,
              onActionClick: props.onCancel,
            },
            {
              text: "Withdraw",
              isPrimary: true,
              disabled: !formState.reason,
              isLoading: isLoading,
              onActionClick: async () => {
                setIsLoading(true);
                try {
                  await props.onWithdraw(formState.reason);
                } catch (error) {
                  console.error(error);
                } finally {
                  setIsLoading(false);
                }
              },
            },
          ]}
        />
      </Footer>
    </section>
  );
};
